<template>
    <section
        class="accordion"
        :class="{ 'add-padding': !collapsed }"
    >
        <div class="accordion__title">
            <a @click="toggleCollapsed">{{ header }}
                <img
                    class="accordion-activator"
                    :class="{ rotate: collapsed }"
                    src="data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23002664' d='M12 2c0-.1 0-.1-.1-.2L10.3.1c-.1-.1-.3-.1-.4 0L6 4 2.1 0c-.1 0-.3 0-.4.1L.1 1.7c-.1.1-.1.3 0 .4l5.7 5.8c.1.1.3.1.4 0l5.7-5.8c.1 0 .1-.1.1-.1z'/%3E%3C/svg%3E"
                >
            </a>
        </div>
        <div
            class="accordion__body"
            :class="{ collapse: collapsed }"
        >
            <slot/>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Accordion",
        props: {
            header: {
                type: String,
                default: ""
            }
        },
        data: () => ({
            collapsed: true
        }),
        methods: {
            toggleCollapsed () {
                this.collapsed = !this.collapsed
            }
        }
    }
</script>

<style lang="scss" scoped>
    .accordion {
        transition: all .5s ease;

        .accordion__title {
            font-size: 16px;
            cursor: pointer;
            padding-bottom: 20px;
        }

        .accordion__body {
            display: block;
            transition: all .5s ease;
            max-height: 1500px;
            overflow: hidden;
            margin: 0;

            &.collapse {
                max-height: 0;
            }
        }

        .accordion-activator {
            padding-right: 0.5rem;
            transform: rotate(180deg);
            transition-duration: 0.5s;
            &.rotate {
                padding-left: 0.5rem;
                transform: rotate(0deg);
                transition-duration: 0.5s;
            }
        }

        &.add-padding {
            padding-bottom: 1.4rem;
        }
    }

    div {
        margin-bottom: 0 !important;
    }
</style>
